import React from "react";
import styled from "styled-components";
import { FiInfo, FiClock, FiMessageSquare, FiGrid } from "react-icons/fi";
import { Link } from "react-router-dom";
import { onDesktop, OnlyOnDesktop, OnlyOnMobile } from "../utils/breakpoint";
import colors from "../utils/colors";

interface IProps {
  title: string;
  icon: string;
  redirect: string;
  showOnDesktop: boolean;
  active: boolean;
  customColor: string;
}

const ButtonContainer = styled.div`
  height: 100%;
  box-sizing: border-box;
  width: 70px;
  border: 0;
  border-bottom: 2px solid
    ${(p: IProps) => (p.active ? (p.customColor ? p.customColor : colors.BLUE) : "transparent")};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0;
  &:focus {
    outline: none;
  }
  background-color: inherit;

  ${onDesktop} {
    flex-direction: row;
    width: auto;
  }
`;

const NormalLink = styled(Link)`
  ${onDesktop} {
    flex: 1 1 0;
  }
  margin: 0 8px;
`;

const LinkWhichIsOnlyShownOnMobile = styled(Link)`
  ${onDesktop} {
    display: none;
  }
`;

const NavBtnTitle = styled.p`
  margin-top: 2px;
  height: 12px;
  font-size: 10px;
  font-weight: 500;
  letter-spacing: 0.36px;
  line-height: 12px;

  ${onDesktop} {
    margin-left: 8px;
    font-size: 16px;
    color: ${(p: IProps) => (p.customColor ? p.customColor : colors.BLUE)};
  }
`;

const NavButton: React.FunctionComponent<IProps> = (props: IProps) => {
  const { title, icon, redirect, showOnDesktop, customColor } = props;

  const StyledLink = showOnDesktop ? NormalLink : LinkWhichIsOnlyShownOnMobile;

  const renderIcon = () => {
    switch (icon) {
      case "info":
        return (
          <>
            <OnlyOnDesktop>
              <FiInfo style={{ color: customColor }} size={20} />
            </OnlyOnDesktop>
            <OnlyOnMobile>
              <FiInfo size={20} />
            </OnlyOnMobile>
          </>
        );

      case "clock":
        return (
          <>
            <OnlyOnDesktop>
              <FiClock style={{ color: customColor }} size={20} />
            </OnlyOnDesktop>
            <OnlyOnMobile>
              <FiClock size={20} />
            </OnlyOnMobile>
          </>
        );
      case "floor":
        return (
          <>
            <OnlyOnDesktop>
              <FiGrid style={{ color: customColor }} size={20} />
            </OnlyOnDesktop>
            <OnlyOnMobile>
              <FiGrid size={20} />
            </OnlyOnMobile>
          </>
        );
      case "msg":
        return (
          <>
            <OnlyOnDesktop>
              <FiMessageSquare style={{ color: customColor }} size={20} />
            </OnlyOnDesktop>
            <OnlyOnMobile>
              <FiMessageSquare size={20} />
            </OnlyOnMobile>
          </>
        );
    }
  };

  return (
    <StyledLink to={`${redirect}`} style={{ textDecoration: "none" }}>
      <ButtonContainer {...props}>
        {renderIcon()}
        <NavBtnTitle {...props}>{title}</NavBtnTitle>
      </ButtonContainer>
    </StyledLink>
  );
};
export default NavButton;
